/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m6.75 9.4393-3.5303 3.5304a.75.75 0 0 0 1.0607 1.0606c.0001-.0002-.0003.0002 0 0L6.75 11.5607l4.5 4.5 11.7799-11.78c.0001 0-.0002.0002 0 0a.75.75 0 1 0-1.0602-1.0611L11.25 13.9394l-4.5-4.5ZM.75 0a.75.75 0 0 1 .75.75V22.5h21.75a.75.75 0 0 1 0 1.5H0V.75A.75.75 0 0 1 .75 0Z"
    clipRule="evenodd"
  />,
  'Graph'
);
